import { BaseDataService } from './BaseDataService';
import { Question, SurveyVersion, Organization } from '../../models';
import { NotificationService } from '../../services';

export class GridOptionDataService extends BaseDataService<Question> {
    constructor(notificationService: NotificationService) {
        super('GridOption', 'GridOptions', notificationService);
    }

    public getAllBySurveyVersion(surveyVersion: SurveyVersion, organization: Organization | undefined): Promise<any> {
        var endpoint = `${this.endpointRoot}/all/${surveyVersion.id}`;
        if (organization) {
            endpoint += `/${organization.id}`;
        }
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving statements.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

}


// WEBPACK FOOTER //
// ./src/services/api/GridOptionData.tsx